/**********************************************************************************************************************
 * Responsibility: This component is responsible for rendering the action items for each order. 🐺
 * ***********************************************************************************************
 *
 * @format
 * */

import {DuplicateOrderButton} from 'frontier/account/components/shared/duplicate_order_button';
import DimensionValidator from 'frontier/utilities/dimension_validator';
import {ArchiveOrder} from '../../design_actions/archive_order';
import {If, IfElse} from 'frontier-utilities';
import React from 'react';
import {
    LAMINATE_THERMAL_GLOSS_FINISH,
    PRODUCT_TYPE_GRAPHIC_DESIGN,
    SHAPE_CARTON_CUSTOM,
    SIZE_STATUS_INSTOCK,
    SHAPE_CUSTOM
} from 'frontier-constants';

// styles
import './action_column.scss';

export const ActionColumn = props => {
    const {onRemoveItemFromList, order} = props;

    const viewShippingSummaryPath = `/account/orders/preview-cart-summary/${order.cart_id}`;
    const viewInvoicePath = `/account/orders/preview-current-invoice/${order.cart_id}`;

    const dmv = new DimensionValidator({
        productTypeId: order.product_type_id,
        shapeId: order.shape_id,
        length: order.length,
        width: order.width,
        depth: order.depth
    });

    const isReorderPossible =
        order.product_type_id !== PRODUCT_TYPE_GRAPHIC_DESIGN &&
        order.laminate_id !== LAMINATE_THERMAL_GLOSS_FINISH &&
        !order.is_archived &&
        (dmv.isValidSize() ||
            parseInt(order.shape_id) === SHAPE_CARTON_CUSTOM ||
            order.size.status_id === SIZE_STATUS_INSTOCK ||
            parseInt(order.shape_id) === SHAPE_CUSTOM);

    return (
        <div className={'designs_table__action-column-12bg'}>
            <a
                className="d-flex align-items-center justify-content-start color-accent-primary gap-2"
                rel="noopener noreferrer"
                href={viewInvoicePath}
                target="_blank">
                <i className="fa fa-eye" />
                <span>View Invoice</span>
            </a>
            <If condition={order.product_type_id !== PRODUCT_TYPE_GRAPHIC_DESIGN}>
                <a
                    className="d-flex align-items-center justify-content-start color-accent-primary gap-2"
                    href={viewShippingSummaryPath}
                    rel="noopener noreferrer"
                    target="_blank">
                    <i className="fa fa-truck" />
                    <span>Shipping summary</span>
                </a>
            </If>
            <If condition={isReorderPossible}>
                <div className="action-column-12bg__duplicate-order">
                    <DuplicateOrderButton id={order.id}>
                        <DuplicateOrderCustomButton />
                    </DuplicateOrderButton>
                </div>
            </If>
            <IfElse condition={order.is_archived}>
                <div
                    className="p-0 m-0 color-accent-tertiary d-flex align-items-center justify-content-start"
                    data-filename="reorder_orders/design_actions/archive_design.jsx"
                    style={{color: `rgb(229, 178, 0)`}}>
                    <i className="fa fa-triangle-exclamation me-2" />
                    <span style={{lineHeight: 1}}>Order archived</span>
                </div>
                <ArchiveOrder order={order} onArchive={onRemoveItemFromList} />
            </IfElse>
        </div>
    );
};

function DuplicateOrderCustomButton(props) {
    const {isPending, handleDuplicate} = props;

    return (
        <IfElse condition={!isPending}>
            <button
                className="d-flex align-items-center justify-content-center gap-2 color-accent-primary"
                onClick={handleDuplicate}>
                <i className="fas fa-history" />
                <u>Create New Order</u>
            </button>
            <button
                disabled
                className="d-flex align-items-center justify-content-center gap-2 color-structure-darker">
                <i className="fas fa-spin fa-spinner" />
                <u>Duplicating</u>
            </button>
        </IfElse>
    );
}
